import { Plus, Trash2, Pill } from 'lucide-react'
import { Input } from '@/components/common/Input'
import { Button } from '@/components/common/Button'
import { StepShell } from '../StepShell'
import { EmptyState } from '@/components/common/Loader'

const blankRow = () => ({ medicine: '', dosage: '', duration: '' })
const DEFAULT = { medicines: [] }

export function PrescriptionStep({ value, onChange }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  const addRow = () => set({ medicines: [...v.medicines, blankRow()] })
  const updateRow = (i, patch) =>
    set({ medicines: v.medicines.map((r, idx) => (idx === i ? { ...r, ...patch } : r)) })
  const removeRow = (i) =>
    set({ medicines: v.medicines.filter((_, idx) => idx !== i) })

  return (
    <StepShell
      eyebrow="Section 12 — Phase 5"
      title="Prescription"
      description="Medicines, dosage and duration. Add one row per drug."
    >
      {v.medicines.length === 0 ? (
        <div className="rounded-2xl bg-white shadow-soft ring-1 ring-ink-100">
          <EmptyState
            icon={<Pill className="h-6 w-6" />}
            title="No medicines added"
            description="Click the button below to add the first medicine."
            action={
              <Button onClick={addRow} leftIcon={<Plus className="h-4 w-4" />}>
                Add medicine
              </Button>
            }
          />
        </div>
      ) : (
        <div className="space-y-3">
          {v.medicines.map((row, i) => (
            <div
              key={i}
              className="grid gap-3 rounded-2xl bg-white p-4 shadow-soft ring-1 ring-ink-100 sm:grid-cols-[1.5fr_1fr_1fr_auto] sm:items-end"
            >
              <Input
                label={i === 0 ? 'Medicine' : undefined}
                value={row.medicine}
                onChange={(e) => updateRow(i, { medicine: e.target.value })}
                placeholder="e.g. Amoxicillin 500mg"
              />
              <Input
                label={i === 0 ? 'Dosage' : undefined}
                value={row.dosage}
                onChange={(e) => updateRow(i, { dosage: e.target.value })}
                placeholder="e.g. 1-0-1 after food"
              />
              <Input
                label={i === 0 ? 'Duration' : undefined}
                value={row.duration}
                onChange={(e) => updateRow(i, { duration: e.target.value })}
                placeholder="e.g. 5 days"
              />
              <Button
                variant="ghost"
                size="icon"
                onClick={() => removeRow(i)}
                title="Remove"
                className="text-rose-600 hover:bg-rose-50"
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          ))}
          <Button
            variant="secondary"
            onClick={addRow}
            leftIcon={<Plus className="h-4 w-4" />}
          >
            Add another medicine
          </Button>
        </div>
      )}
    </StepShell>
  )
}
